export const saveCanvas = (canvas, fileName) => {
  const blob = canvas.msToBlob
    ? canvas.msToBlob()
    : canvas.toDataURL("image/png");
  if (!blob) throw new Error("No data found in the canvas");

  saveFile(blob, fileName);
};

let downloadAnchor;

export const saveFile = (blob, fileName) => {
  if (navigator.msSaveOrOpenBlob) {
    navigator.msSaveOrOpenBlob(blob, fileName);
  } else {
    if (!downloadAnchor) downloadAnchor = document.createElement("a");

    downloadAnchor.download = fileName;
    downloadAnchor.href = URL.createObjectURL(blob);
    downloadAnchor.click();
  }
};
